module.exports = __webpack_public_path__ + "img/clouds_night.eaa3c34d.jpg";